import type { CmsApiBlockType } from '#/modules/cms/api/types/CmsApiBlock';

export function getNextRealBlock<T extends { type: CmsApiBlockType }>(
  blocks: T[],
  i: number,
): T | undefined {
  for (let j = i + 1; j < blocks.length; j += 1) {
    const block = blocks[j];
    if (block?.type !== 'SCROLL_TRACKING') {
      return block;
    }
  }

  return undefined;
}
